import type { AppearingTextProps } from "@ancestors/components/AppearingText";
import { AppearingText } from "@ancestors/components/AppearingText";
import { Howl } from "howler";
import { useCallback } from "react";
import { randomArrayElement } from "~/lib/utils";

const sound = new Howl({
  src: "/word-appear.webm",
  volume: 0.1,
});

const rates = [
  1, // 1109
  1.3345356177, // 1480
  0.7489630298, // 830.6
  0.5611361587, // 622.3
];

export function AppearingTextWithSound({ onWordAppearing, ...props }: AppearingTextProps) {
  const onWordAppearingWithSound = useCallback(() => {
    onWordAppearing?.();
    const rate = randomArrayElement(rates);
    sound.rate(rate, sound.play());
  }, [onWordAppearing]);

  return <AppearingText {...props} onWordAppearing={onWordAppearingWithSound} />;
}
